export const ChatContentType = {
  QUESTION_REQUIRE: 'QUESTION_REQUIRE', // 问题咨询
  POSITION_REQUIRE: 'POSITION_REQUIRE', // 职位要求
  POSITION_RECOMMEND: 'POSITION_RECOMMEND', // 职位推荐
  RESUME_FLOW: 'RESUME_FLOW', // 简历流程
};